

var swiper = new Swiper(".custom-banner-slider", {
      spaceBetween: 0,
      centeredSlides: true,
      // autoplay: {
      //    delay: 4000,
      // },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });

var swiper = new Swiper(".category-slider", {
    slidesPerView: 1, 
    spaceBetween: 10,
    pagination: {
        el: ".swiper-pagination", 
        clickable: true,
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        1025: {
            slidesPerView: 3,
        }
    }
});


var swiper = new Swiper(".hero-slider", {
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
  });

var swiper = new Swiper(".recomendation-slider", {
    slidesPerView: 1, 
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        1025: {
            slidesPerView: 3,
        }
    }
})

window.onload = function() {
    swiper.update(); // Update Swiper after the page has fully loaded
};
